var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "book-open-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.333 21L12.233 20.8499C11.5383 19.808 11.191 19.287 10.7321 18.9098C10.3259 18.5759 9.85777 18.3254 9.35461 18.1726C8.78626 18 8.16012 18 6.90783 18H5.53301C4.4129 18 3.85285 18 3.42503 17.782C3.0487 17.5903 2.74274 17.2843 2.55099 16.908C2.33301 16.4802 2.33301 15.9201 2.33301 14.8V6.2C2.33301 5.07989 2.33301 4.51984 2.55099 4.09202C2.74274 3.71569 3.0487 3.40973 3.42503 3.21799C3.85285 3 4.4129 3 5.53301 3H5.93301C8.17322 3 9.29332 3 10.149 3.43597C10.9016 3.81947 11.5135 4.43139 11.897 5.18404C12.333 6.03968 12.333 7.15979 12.333 9.4M12.333 21V9.4M12.333 21L12.4331 20.8499C13.1277 19.808 13.475 19.287 13.9339 18.9098C14.3402 18.5759 14.8082 18.3254 15.3114 18.1726C15.8798 18 16.5059 18 17.7582 18H19.133C20.2531 18 20.8132 18 21.241 17.782C21.6173 17.5903 21.9233 17.2843 22.115 16.908C22.333 16.4802 22.333 15.9201 22.333 14.8V6.2C22.333 5.07989 22.333 4.51984 22.115 4.09202C21.9233 3.71569 21.6173 3.40973 21.241 3.21799C20.8132 3 20.2531 3 19.133 3H18.733C16.4928 3 15.3727 3 14.517 3.43597C13.7644 3.81947 13.1525 4.43139 12.769 5.18404C12.333 6.03968 12.333 7.15979 12.333 9.4",
    stroke: "#145DD7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen);
export default __webpack_public_path__ + "static/media/book-open.41e3ed03c5cdd604f24c4f00ba73099f.svg";
export { ForwardRef as ReactComponent };